wbApp.controller('RentsDetailCtrl', ['$scope', '$modal', 'rentSvc', 'notRegisteredUserSvc',
function ($scope, $modal, rentSvc, notRegisteredUserSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    if ($scope.model.isNew) {
        $scope.statusDisabledSelection = [1, 3, 4, 5];
    } else {
        $scope.statusDisabledSelection = [];
    }

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {
            rentSvc.insert(data)
                .$promise.then(success, error);
        } else {
            rentSvc.update(data)
                .$promise.then(success, error);
        }

        function success(newModel) {
            $scope.onRentSave(newModel);
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    //$scope.detailIsUnchanged = function (data) {
    //    return angular.equals(data, $scope.modelOrig);
    //};


    $scope.isFormValid = function() {
        return true;
    }

    $scope.removeItem = function ($index) {
        $scope.model.rentedItems.splice($index, 1);
    }


    $scope.addItem = function () {
        addItemDialogPromise.$promise.then(function () {
            addItemDialogPromise.$scope.placeId = $scope.model.placeId;
            addItemDialogPromise.$scope.onAddItemDetailSave = function (items) {

                var union = _.unionWith($scope.model.rentedItems, items, function (arrVal, othVal) {
                    return (arrVal.id == othVal.id) && !!arrVal.id && !!othVal.id;
                });

                $scope.model.rentedItems.length = 0;
                $scope.model.rentedItems.push.apply($scope.model.rentedItems, union);
            };
            addItemDialogPromise.show();
        });
    }

    var addItemDialogPromise = $modal({
        templateUrl: 'rents/rent/rent-detail-add-item-detail.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.fromUtcPickerOptions = {
        type: "datetime",
        width: '100%'
    };

    $scope.toUtcPickerOptions = {
        type: "datetime",
        width: '100%'
    };

    $scope.onAnonymousBtnClick = function () {
        
        if (!$scope.model.notRegisteredUserInfo) {
            $scope.model.notRegisteredUserInfo = notRegisteredUserSvc.createNew();
        }
        $scope.model.isNotRegisteredUser = true;
        $scope.model.userID = null;
        $scope.model.studentId = null;
    }

    $scope.onExistingBtnClick = function () {
        $scope.model.userID = null;
        $scope.model.studentId = null;
        $scope.model.isNotRegisteredUser = false;
    }

    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "rents/rent/rent-detail-main-tab.html"
    },
    {
        title: 'TXT_LBL_USER',
        template: "rents/rent/rent-detail-user-tab.html"
    },
    {
        title: 'TXT_LBL_NOTES',
        template: "rents/rent/rent-detail-notes-tab.html"
    },
    {
        title: 'TXT_RENT_STATUS',
        template: "rents/rent/rent-detail-status-history-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;
}]);
